import * as React from "react"
import { trackEvent } from "../utils/trackEvent"

type LeadFormContextType = {
  isOpen: boolean
  /** Open the PM lead modal. Pass a `source` (e.g. "hero", "nav") to log which
   * CTA drove the open as a `cta_click` funnel event. */
  open: (source?: string) => void
  close: () => void
}

const LeadFormContext = React.createContext<LeadFormContextType | undefined>(
  undefined
)

export const LeadFormProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const open = React.useCallback((source?: string) => {
    trackEvent("cta_click", { form_id: "pm_modal", ...(source ? { cta_source: source } : {}) })
    setIsOpen(true)
  }, [])
  const close = React.useCallback(() => setIsOpen(false), [])
  const value = React.useMemo(
    () => ({ isOpen, open, close }),
    [isOpen, open, close]
  )

  return (
    <LeadFormContext.Provider value={value}>
      {children}
    </LeadFormContext.Provider>
  )
}

export const useLeadForm = (): LeadFormContextType => {
  const ctx = React.useContext(LeadFormContext)
  if (!ctx) {
    throw new Error("useLeadForm must be used within LeadFormProvider")
  }
  return ctx
}
